import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../../app/features/store/store";
import { Outlet, useNavigate } from "react-router-dom";
import Login from "./Login";
import Loader from "../../components/common/loader/Loader";
import { fetchFdpDriverSelectedEmail } from "../../app/features/fdp/fdpSlice";

const RequireAuth = () => {
  const authResponse = useSelector(
    (state: RootState) => state.login.authResponse
  );
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const tokenDetails = authResponse?.tokenDetails;
  const isLoggedIn =
    tokenDetails || localStorage.getItem("isLoggedIn") === "true";
  const isLoginLoading = useSelector(
    (state: RootState) => state.login.isLoginLoading
  );
  const isFdpPerson = authResponse?.isFdp;

  useEffect(() => {
    const currentPath = window.location.pathname;
    navigate(currentPath, { replace: true });
  }, [navigate]);

  useEffect(() => {
    const fetchDriverSelectedAcc = async () => {
      try {
        await dispatch(fetchFdpDriverSelectedEmail()).unwrap();
      } catch (error) {
        console.error("Error fetching client email data:", error);
      }
    };
    if (isFdpPerson) {
      fetchDriverSelectedAcc();
    }
  }, [dispatch, isFdpPerson]);

  if (isLoginLoading) return <Loader isLoading={isLoginLoading} />;

  return isLoggedIn ? <Outlet /> : <Login />;
};

export default RequireAuth;
